module.exports = __webpack_public_path__ + "img/icon-16.567c1301.svg";